import { baseEnvironment } from './environment.base';
import { EnvironmentModel } from '@privanot/shared-models';

export const environment: EnvironmentModel = {
    ...baseEnvironment,
    name: 'dev2',
    BASE_URL: 'https://privanotclient2devb7c82b77-privanot-client-service.functions.fnc.fr-par.scw.cloud',
    isDevelopment: true,
    isProduction: false,
    featureFlags: {},
};
